// eslint-disable-next-line eag/no-external-date-time-format-functions -- TODO [T20-67958]
import {format} from 'date-fns';
import {convertStringLocaleToDateFns, useLocale} from 'platform/locale';

import {Nullish} from 'shared/web';

export function useGetManufacturedOn(date: string | Nullish) {
  const {language} = useLocale();

  if (!date) {
    return '';
  }

  return format(date, 'LLLL yyyy', {
    locale: convertStringLocaleToDateFns(language),
  });
}
